var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscreenView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.55,13.4a1,1,0,0,0-1.48,0l-5,5V15.8A1,1,0,1,0,2,15.8v5A1.18,1.18,0,0,0,3.18,22h5a1,1,0,1,0,0-2.08H5.5l5.05-5.05A1.05,1.05,0,0,0,10.55,13.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.45,10.6a1,1,0,0,0,1.47,0l5-5V8.2A1,1,0,0,0,22,8.2v-5A1.19,1.19,0,0,0,20.81,2h-5a1,1,0,0,0,0,2.08h2.68l-5,5.05A1,1,0,0,0,13.45,10.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenView);
export default __webpack_public_path__ + "static/media/fullscreen-view.fa4a14d541b28e14ce54dff0daf1ad1f.svg";
export { ForwardRef as ReactComponent };